export const POST_STATUS_BADGES = {
  canceled: { label: "Canceled", variant: "primary" },
  failed: { label: "Failed", variant: "error" },
  published: { label: "Published", variant: "success" },
  publishing: { label: "Publishing", variant: "brand" },
  scheduled: { label: "Scheduled", variant: "brand" },
} as const;
